import { render } from "./CIS-RichText.vue?vue&type=template&id=cfd458ac"
import script from "./CIS-RichText.vue?vue&type=script&lang=js"
export * from "./CIS-RichText.vue?vue&type=script&lang=js"

import "./CIS-RichText.vue?vue&type=style&index=0&id=cfd458ac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__